// extracted by mini-css-extract-plugin
export var primaryColor = "#00b2ff";
export var primaryFont = "Nexa";
export var primaryFontHeavy = "NexaHeavy";
export var secondaryColor = "#00fff0";
export var secondaryFont = "Inter";